import { Link } from 'react-router-dom';

export default function Navbar() {
  return (
    <nav
      style={{
    display: 'flex',
    alignItems: 'center',
    background: '#f5f9faff',
    padding: '12px 24px',
    height: '64px',
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 1000,
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    boxSizing: 'border-box'
      }}
    >
      <div style={{ flex: '0 0 auto' }}>
        <img
          src="/images/logo.png"
          alt="Logo"
          style={{ height: '40px', cursor: 'pointer' }}
        />
      </div>

      {/* Spacer to push menu items towards center */}
      <div style={{ flex: '1 1 auto' }}></div>

      <div
        style={{
          display: 'flex',
          gap: '32px',
          justifyContent: 'center',
          flex: '3 1 auto',
        }}
      >
        <Link to="/" style={{ color: 'black', textDecoration: 'none', alignSelf: 'center' }}>
          Home
        </Link>
        <Link to="/solutions" style={{ color: 'black', textDecoration: 'none', alignSelf: 'center' }}>
          Solutions
        </Link>
        <Link to="/about" style={{ color: 'black', textDecoration: 'none', alignSelf: 'center' }}>
          About
        </Link>
        <Link to="/contact" style={{ color: 'black', textDecoration: 'none', alignSelf: 'center' }}>
          Contact
        </Link>
        <Link to="/resources" style={{ color: 'black', textDecoration: 'none', alignSelf: 'center' }}>
          Resources
        </Link>
      </div>

      {/* Spacer to push Ask Demo to right */}
      <div style={{ flex: '1 1 auto' }}></div>

      <div style={{ flex: '0 0 auto' }}>
        <Link
          to="/ask-demo"
          style={{
            background: 'rgba(11, 128, 17, 1)',
            padding: '6px 14px',
            fontWeight: 'bold',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '4px',
            whiteSpace: 'nowrap',
            cursor: 'pointer',
          }}
        >
          Ask Demo
        </Link>
      </div>
    </nav>
  );
}
